module.exports = __webpack_public_path__ + "img/code.9f9702a1.png";